<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-4">
          <h1 class="mt-5">
            Report Layouts
            <i *ngIf="loadingData" class="fas fa-spinner fa-pulse"></i>
          </h1>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <mat-select [(ngModel)]="selectedInteractive" (selectionChange)="interactiveChanged($event)">
            <mat-option *ngFor="let interactive of layoutInteractives" [value]="interactive">{{interactive.interactName}}</mat-option>
          </mat-select>
        </div>
        <div class="col-md-2" style="margin-top: 6px">
          <a href="#" (click)="createLayout()"><span class="fas fa-file" title="Create New Layout">&nbsp;&nbsp;Create New Layout</span></a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 mainLabel"></div>
        <div class="col-md-4 mainLabel">Layout Name</div>
        <div class="col-md-4 mainLabel">Owner</div>
        <div class="col-md-2 mainLabel">Last Run (UTC)</div>
      </div>
      <ng-container *ngIf="selectedInteractive && selectedInteractive.podLayouts">
        <ng-container *ngFor="let layout of selectedInteractive.podLayouts">
          <div class="row table-row">
            <div class="col-md-2" style="margin-top: 5px">
              <a href="#" (click)="launchPrintNow(layout)"><span class="fas fa-print" title="Print Now"></span></a>&nbsp;
              <ng-container *ngIf="layout.allowEditing">
                <a href="#" (click)="editLayout(layout)"><span class="fas fa-edit" title="Print Preview / Edit"></span></a>&nbsp;
              </ng-container>
              <ng-container *ngIf="layout.isOwner">
                <a href="#" (click)="deleteLayout(layout)"><span class="fas fa-trash" title="Delete"></span></a>&nbsp;
              </ng-container>
              <ng-container *ngIf="!layout.recurring">
                <a href="#" (click)="createRecurring(layout)"><span class="fas fa-calendar-plus" title="Create Scheduled Report"></span></a>
              </ng-container>
              <ng-container *ngIf="layout.recurring">
                <a href="#" (click)="editRecurring(layout.recurring)"><span class="fas fa-calendar-day" title="Edit Scheduled Report"></span></a>&nbsp;
                <a href="#" (click)="deleteRecurring(layout.recurring)"><span class="fas fa-calendar-times" title="Delete Scheduled Report"></span></a>&nbsp;
                <a href="#" (click)="generateRecurring(layout.recurring)"><span class="fas fa-file-export" title="Generate Now"></span></a>
              </ng-container>
            </div>
            <div class="col-md-4">{{ layout.name }}</div>
            <div class="col-md-4">{{ layout.createdBy }} / {{ layout.organizationName }}</div>
            <div class="col-md-2">
              <ng-container *ngIf="layout.recurring && layout.recurring.lastRun">
                {{ layout.recurring.lastRun | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}
              </ng-container>
              <ng-container *ngIf="layout.recurring && !layout.recurring.lastRun">
                Never Ran
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>

<div [hidden]="!showPowerBi" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1000; background-color: #106bae">
  <app-powerbi-embed (closeClicked)="closeInteractiveClicked()"></app-powerbi-embed>
</div>
